import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import FreeCreditEvaluationWrapper from "@components/layouts/freeCreditEvaluationWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <FreeCreditEvaluationWrapper>
            <PrivacyPolicy
                category="Credit Repair"
                domain="FreeCreditEvaluation.com"
            />
        </FreeCreditEvaluationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
